import { Typography , Button, Toolbar, Avatar} from '@mui/material'
import { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux' ;
import {logOut} from '../../actions/auth';
import { useNavigate , useLocation} from 'react-router-dom'
import {Link} from  'react-router-dom';
import decode from 'jwt-decode';

const Navbar = () => {
    //getting the user auth data from the localstorage as we saved it there using the auth Reducer    
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')) )
  
    const dispatch = useDispatch();       //getting the dispatch function
    const navigate = useNavigate();       //getting the router-dom navigate function = useHistory upgrade
    const location = useLocation();        //gets URL info & change whenever the URL changes   

    const handleLogOut =() =>{            //function for log out button      
        dispatch(logOut());
        navigate('/auth') ;         
        setUser(null);;
    }

    useEffect(() => {        //when navbar render & location changes ,check token & setUser immediatly to new auth values
      const token = user?.token ;
      if (token){  //check if the token expired after 1h , so we logout automatically
        const decodedToken = decode(token);
        if (decodedToken.exp * 1000 < new Date().getTime()) { handleLogOut() } 
      }
      setUser(JSON.parse(localStorage.getItem('profile'))) ;
    }, [location])  ;  
      
  return (
    //render the navbar using material ui components 
    <nav className="navbar">   
      
      <Link to='/'><div style={{display:'flex',alignItems:'center'}}> 
          <img src='/images/memories-Text.png' alt="Memories" height='50' style={{margin:'0 10px 0 5px'}} />
          <img src='/images/memories-Logo.png' alt="Memories" height='45' />
        </div> </Link>

      <Toolbar >
           {user? (<div className='user' >
                       <Avatar sx={{backgroundColor:'#9c27b0'}} alt={user.result.name} src={user.result.imageUrl}>
                           {user.result.name.charAt(0)}   </Avatar>
                        <Typography sx={{ display: 'flex',alignItems:'center',}} variant='h6'>{user.result.name}</Typography>
                        <Button variant='contained' color='secondary' onClick={handleLogOut}> Log out </Button>
                   </div>) 
             : (<Link to='/auth'><Button variant='contained' color='primary'>Sign in</Button></Link>) }
      </Toolbar>  
    
    </nav>    
  )
}

export default Navbar